export enum RequestLookupType {
    None,
    PackIdentifer,
    UPRC,
    TransactionId
}